module.exports = __webpack_public_path__ + "img/style_swiper_03_active.b2d9c2e3.png";